import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/pro-duotone-svg-icons';
import { faTimes } from '@fortawesome/pro-light-svg-icons';

// Actions
import { createAgency, updateAgency } from '../../../actions/agency';
import { createAgent } from '../../../actions/agent';

// Components
import Input from './Input';
import { ModalBase, Spinner } from '../../../common/components';


export default function AddAgency() {
  const dispatch = useDispatch();
  const {
    addagency: {
      values,
      error,
      validations,
      saving,
      editing,
      create_manager: createManager,
    },
    modals: { addEditAgencyInfoOpen: isOpen },
    theme: { validation },
  } = useSelector(store => store);

  function close() {
    dispatch({ type: 'CLOSE_MODAL', modal: 'addEditAgencyInfoOpen' });
    dispatch({ type: 'CLEAR_ADD_AGENCY' });
    dispatch({ type: 'TOGGLE_CREATE_MANAGER', payload: false });
    dispatch({ type: 'CLEAR_AGENCY_ERROR' });
  }

  function toggleCreateManager({ target }) {
    dispatch({ type: 'TOGGLE_CREATE_MANAGER', payload: target.checked });
  }

  function handleSave() {
    if (!editing) {
      dispatch({ type: 'ADD_AGENCY_SAVE' });

      if (createManager) {
        createAgency({ ...values })
          .then((data) => {
            const nameArray = values.contact_name.split(' ');
            const firstName = nameArray[0];
            const lastName = nameArray[1];
            createAgent({
              first_name: firstName || '',
              last_name: lastName || '',
              email: values.contact_email,
              agency: data.id,
              mobile_phone: values.contact_phone,
              is_agency_admin: true,
              is_admin: false,
              can_quote: true,
            })
              .then(close())
              .catch(() => {
                dispatch({ type: 'ADD_AGENCY_CLEAR_SAVE' });
              });
          })
          .catch(() => {
            dispatch({ type: 'ADD_AGENCY_ERROR' });
            dispatch({ type: 'ADD_AGENCY_CLEAR_SAVE' });
          });
      } else {
        createAgency({ ...values })
          .then(close())
          .catch(() => {
            dispatch({ type: 'ADD_AGENCY_CLEAR_SAVE' });
          });
      }
    } else {
      dispatch({ type: 'ADD_AGENCY_SAVE' });
      updateAgency(values.id, values)
        .then(close())
        .catch(() => {
          dispatch({ type: 'ADD_AGENCY_CLEAR_SAVE' });
        });
    }
  }

  const erroring = !Object.values(validations).reduce((prev, curr) => prev && curr, true);

  return (
    <ModalBase
      isOpen={isOpen}
      closeModalAction={() => close()}
      staticWidth="73vw"
      hideHeader="true"
      padding="0"
      style={{
        overflowX: 'hidden',
        borderRadius: '1rem',
        top: '4vh',
        position: 'absolute',
      }}
    >
      <div className="px-5 py-3 h4 d-flex justify-content-between align-items-center border-bottom">
        {editing ? 'Edit Agent Group Information' : 'Create Agent Group'}
        <button type="button" className="btn" onClick={() => close()}>
          <FontAwesomeIcon icon={faTimes} size="lg" />
        </button>
      </div>
      <div className="px-5 py-3 row">
        <div className="col-6">
          <Input id="name" pattern={validation.agency_name} label="Agent Group Name:" />
          <Input id="description" pattern={validation.description} label="Description:" />
        </div>
        <div className="col">
          <Input id="contact_name" pattern={validation.contact_name} label="Contact Name:" />
          <Input id="contact_phone" pattern={validation.contact_phone} label="Contact Phone:" />
          <Input
            id="contact_email"
            // @see https://emailregex.com/
            // eslint-disable-next-line max-len
            pattern={/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/}
            label="Contact Email:"
            feedback="Email already in use."
          />
        </div>
      </div>
      {!editing
        ? (
          <div className="px-5 row">
            <div className="ms-3 mb-3">
              <input
                type="checkbox"
                id="contact_info"
                className="d-inline"
                onChange={(e) => toggleCreateManager(e)}
              />
              <span className="ms-2">
                Create an initial agent group manager account that can login to the
                agent portal. Please provide a Contact Email.
              </span>
            </div>
          </div>
        ) : null}
      <div className="px-5 pt-1 pb-5 justify-content-start">
        <button
          type="button"
          className="btn btn-primary me-3 text-white px-4"
          onClick={() => handleSave()}
          disabled={saving || erroring}
        >
          <FontAwesomeIcon icon={faSave} size="lg" className="me-2" />
          Save
          {saving && (
            <Spinner size="20" color="white" className="ms-2" />
          )}
        </button>
        <button
          type="button"
          className="px-4 btn btn-outline-dark"
          onClick={() => close()}
          disabled={saving}
        >
          <FontAwesomeIcon icon={faTimes} size="lg" className="me-2" />
          Cancel
        </button>

        {error && (
          <small className="d-inline ms-3 font-weight-bold form-text text-danger">Error! Try Again.</small>
        )}
      </div>
    </ModalBase>
  );
}
